import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from "@angular/common/http";

import { Observable, BehaviorSubject /*throwError*/ } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import { Customer } from '../models/Customer';

@Injectable()
export class RegistrationService {

  private accountIdSrc = new BehaviorSubject('0');
  private orgUnitIdSrc = new BehaviorSubject('0');
  private firstNameSrc = new BehaviorSubject("");
  private lastNameSrc = new BehaviorSubject("");
  private customerUUIDSrc = new BehaviorSubject("");
  private emailSrc = new BehaviorSubject("");
  //private customerIdSrc = new BehaviorSubject("");
  accountId = this.accountIdSrc.asObservable();
  orgUnitId = this.orgUnitIdSrc.asObservable();
  firstName = this.firstNameSrc.asObservable();
  lastName = this.lastNameSrc.asObservable();
  customerUUID = this.customerUUIDSrc.asObservable();
  email = this.emailSrc.asObservable();
  //customerId = this.customerIdSrc.asObservable();

  constructor(private http: HttpClient) { }

  registerUser(customer: Customer): Observable<Number> {
    let _body = JSON.stringify(customer);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    return this.http.post<number>('/Portal/Register', _body, httpOptions);
    //.pipe(
    //  catchError(this.handleError('addHero', email))
    //);
  }

  registerAboutYou(customer: Customer): Observable<Customer> {
    let _body = JSON.stringify(customer);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    return this.http.post<Customer>('/Portal/UpdatePersonalInfo', _body, httpOptions);
    //.pipe(
    //  catchError(this.handleError('addHero', email))
    //);
  }

  mapCustomerToAccount(customer: Customer): Observable<string> {
    let _body = JSON.stringify(customer);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    return this.http.post<string>('/Portal/MapCustomerToAccount', _body, httpOptions);
    //.pipe(
    //  catchError(this.handleError('addHero', email))
    //);
  }

  createUser(customer: Customer): Observable<string> {
    let acctId;
    this.accountId.subscribe(value => acctId = value);
    customer.accountId = acctId;
    let _body = JSON.stringify(customer);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    return this.http.post<string>('/Portal/CreateUser', _body, httpOptions);
  }

  mapUserCustomer(customer: Customer) {
    let _body = JSON.stringify(customer);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    return this.http.post<string>('/Portal/MapUserCustomer', _body, httpOptions);
  }

  viewUtilList(orgUnitId: string, zip: string): Observable<any> {
    const params = new HttpParams()
      .set('orgUnitId', orgUnitId)
      .set('zip', zip);

    return this.http.get<any>('/Portal/GetUtilList', { params });
  }

  updateAccountId(accountId: string) {
    this.accountIdSrc.next(accountId);
  }

  updateEmail(email: string) {
    this.emailSrc.next(email);
  }

  updateOrgUnitId(orgUnitId: string) {
    this.orgUnitIdSrc.next(orgUnitId);
  }

  updateFirstAndLastName(fName: string, lName: string) {
    this.firstNameSrc.next(fName);
    this.lastNameSrc.next(lName);
  }

  updateCustomerId(customerUUID: string) {
    this.customerUUIDSrc.next(customerUUID);
  }

  // PRIVATE FUNCTIONS
  //private handleError(error: HttpErrorResponse) {
  //  if (error.error instanceof ErrorEvent) {
  //    // A client-side or network error occurred. Handle it accordingly.
  //    console.error('An error occurred:', error.error.message);
  //  } else {
  //    // The backend returned an unsuccessful response code.
  //    // The response body may contain clues as to what went wrong,
  //    console.error(
  //      `Backend returned code ${error.status}, ` +
  //      `body was: ${error.error}`);
  //  }
  //  // return an observable with a user-facing error message
  //  return throwError(
  //    'Something bad happened; please try again later.');
  //};
}



// WEBPACK FOOTER //
// ./src/app/services/registration.service.ts